import { render, staticRenderFns } from "./ZoneSettingsForm.vue?vue&type=template&id=20ade4fe&scoped=true&"
import script from "./ZoneSettingsForm.vue?vue&type=script&lang=ts&"
export * from "./ZoneSettingsForm.vue?vue&type=script&lang=ts&"
import style0 from "./ZoneSettingsForm.vue?vue&type=style&index=0&id=20ade4fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ade4fe",
  null
  
)

export default component.exports